import cn from "clsx";
import { useTranslations } from "next-intl";

import { TickIcon } from "@/common/icons";

export const ArtworkCheckListComponent = ({
  titleKey,
  list,
  extraItem,
  className = "",
}: {
  titleKey: string;
  list: string[];
  extraItem?: string;
  className?: string;
}) => {
  const t = useTranslations("common");

  return (
    <div
      className={cn(
        "bg-grey-10 border-grey-20 relative flex h-full flex-col rounded-lg border p-3 lg:p-4",
        className,
      )}
    >
      <div className="border-b-grey-20 absolute left-1/2 top-0 z-0 size-0 -translate-x-1/2 -translate-y-full border-x-[19px] border-b-[19px] border-x-transparent" />
      <div className="border-b-grey-10 absolute left-1/2 top-0 z-10 size-0 -translate-x-1/2 -translate-y-1/2 border-x-[35px] border-b-[35px] border-x-transparent" />

      <div className="text-center text-sm font-semibold lg:text-lg">{t(titleKey)}</div>
      {extraItem && <ListItem item={extraItem} className="font-semibold" />}
      {list.map((item, index) => (
        <ListItem item={item} key={index} />
      ))}
    </div>
  );
};

const ListItem = ({ item, className = "" }: { item: string; className?: string }) => {
  return (
    <div className="mt-1 flex items-center lg:mt-2">
      <div className="size-[16px]">
        <TickIcon fill="#4CB260" stroke="#fff" width="16px" height="16px" />
      </div>
      <div className={cn("ml-1.5 lg:ml-2", className)}>{item}</div>
    </div>
  );
};
